export const configAvailabilityProduct = {
  minAvailabilityNow: 20,
};
